import { Button, CssBaseline, makeStyles, Typography, List, ListItem, Box, Checkbox, TextField, MenuItem } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../../request/values';
import ToastStr from '../../request/toastStr';
import { SubAdminHeaderBar } from '../../shared/header/HeaderBar';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
		//gridTemplateColumns: '230px 1fr',
	},
	mainPage: {
		display: 'flex',
		flexDirection: 'column',
		gap: '5vh',
	},
	classList: {
		'& #classOpen': {
			float: 'right',
			margin: '5px 3%',
			padding: '5px 25px',
			color: `${COLORS.WHITE}`,
			borderRadius: '5px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
			'&:hover': {
				color: `${COLORS.WATER_BLUE}`,
				backgroundColor: 'inherit',
			},
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		height: '60vh',
		margin: '1% 3%',
		borderBottom: '2px solid black',
		//borderRadius: '10px 10px 0 10px',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '1fr 3fr 5fr 3fr 3fr 2fr  17px',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			//background: 'none',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '1.15rem',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
		'& ul': {
			padding: '0',
		},
		'& li': {
			border: 'solid gray',
			borderWidth: '0 0 1px 0',
		},
	},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '1fr 3fr 5fr 3fr 3fr 2fr 17px',
		padding: '25px 0',
		//backgroundColor: `${COLORS.LIGHT_GREY}`,
		backgroundColor: `${COLORS.WHITE}`,
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: 'none',
		fontSize: '1rem',
		fontFamily: 'NanumB',
		//fontWeight: 'bold',
		lineHeight: '21px',
		bolderWidth: '1px',
	},
	blank: {
		display: 'flex',
		height: '40px',
	},
	operApprove: {
		float: 'right',
		margin: '5px 3%',
		padding: '5px 25px',
		color: `${COLORS.WHITE}`,
		borderRadius: '5px',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		'&:hover': {
			color: `${COLORS.WATER_BLUE}`,
			backgroundColor: 'inherit',
		},
	},
	operDelete: {
		float: 'right',
		margin: '5px 3%',
		padding: '5px 25px',
		color: `${COLORS.WHITE}`,
		borderRadius: '5px',
		backgroundColor: `#f50057`,
		'&:hover': {
			color: `#f50057`,
			backgroundColor: 'inherit',
		},
	},
	bottomField: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginTop: '10px',
	},
	selectField: {
		marginLeft: '50%',
		width: '25%',
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(2),
	},
	selectRoot: {
		'& .MuiFormLabel-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiSelect-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 12,
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#cfd4d9',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
			borderWidth: 2,
		},
	},
	selectLabel: {
		backgroundColor: '#fff',
		padding: '0 4px',
	},
	menuPaper: {
		borderRadius: 12,
		boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
		marginTop: 8,
	},
	menuItem: {
		...theme.typography.body1,
		padding: theme.spacing(1.25, 1.5),
		'&:not(:last-child)': {
			borderBottom: '1px solid #f1f3f5',
		},
	},
}));

type iOperList = {
	operator_email: string;
	operator_name: string;
	operator_phone: string;
	join_date: string;
	approve: boolean;
	affiliation: string;
	language: string;
};

const SERVER = basic.server;

const SubAdminOperAffiliate: React.FC<any> = (props) => {
	const classes = useStyles();

	const [ClassList, setClassList] = useState<iOperList[]>([]);
	const [checkedCodes, setCheckedCodes] = useState<String[]>([]);
	const { enqueueSnackbar } = useSnackbar();
	const [page, setPage] = useState(1);
	const loader = useRef(null);
	const [affiliation, setAffiliation] = useState<string | null>(null);

	const postOperAffiliate = () => {
		if (checkedCodes === undefined || checkedCodes.length === 0)
			enqueueSnackbar(ToastStr.OPER_CHECKED_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		else if (affiliation === null)
			enqueueSnackbar(ToastStr.OPER_AFFILIATE_CHECK_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		else {
			axios({
				method: 'POST',
				data: {
					oper_emails: checkedCodes,
					affiliation: affiliation,
				},
				withCredentials: true,
				url: SERVER + v_admin.admin + v_admin.oper_type,
			})
				.then((res) => {
					return res.data;
				})
				.then((data: any) => {
					console.log(data);
					console.log(data.code);
					if (data.code == Values.SUCCESS_CODE) {
						enqueueSnackbar(ToastStr.OPER_AFFILIATE_SUCCESS_STR, {
							variant: 'success',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						if (data.code == Values.FAIL_CODE) {
							enqueueSnackbar(ToastStr.OPER_AFFILIATE_FAIL_STR, {
								variant: 'warning',
								autoHideDuration: SNACKBAR_TIME,
							});
						} else {
							enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
								variant: 'error',
								autoHideDuration: SNACKBAR_TIME,
							});
						}
					}
				})
				.then(() => {
					setPage(1);
					getOperList(1);
					setCheckedCodes([]);
				});
		}
	};

	const getOperList = (page: number) => {
		let url = new URL(SERVER + v_admin.admin + v_admin.oper_list);
		url.searchParams.append('page', String(page));
		url.searchParams.append('limit', '30');
		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					if (page === 1) setClassList(data.data);
					else {
						setClassList((prevClassList) => [...prevClassList, ...data.data]);
					}
				}
			});
	};

	const handleCheckboxChange = (email: String, isChecked: boolean) => {
		setCheckedCodes((prev: any) => {
			if (isChecked) {
				return [...prev, email];
			} else {
				return prev.filter((code: String) => code !== email);
			}
		});
	};

	const handleObserver = useCallback((entries: any) => {
		const target = entries[0];
		if (target.isIntersecting) {
			setPage((prevState) => {
				if (prevState + 1 > 999) {
					return prevState;
				}
				return prevState + 1;
			});
		}
	}, []);

	useEffect(() => {
		const setLoader = () => {
			const option = {
				root: null,
				rootMargin: '20px',
				threshold: 0,
			};
			// console.log('in infinite useEffect')
			const observer = new IntersectionObserver(handleObserver, option);
			if (loader.current) observer.observe(loader.current!);
		};
		setTimeout(() => setLoader(), 100);
	}, [handleObserver]);

	useEffect(() => {
		getOperList(page);
	}, [page]);

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.mainPage}>
					<SubAdminHeaderBar />
					<div className={classes.classList}>
						<div className={classes.table}>
							<div id="title">
								<span>
									<Typography></Typography>
								</span>
								<span>
									<Typography>강사 이름</Typography>
								</span>
								<span>
									<Typography>등록 메일</Typography>
								</span>
								<span>
									<Typography>전화 번호</Typography>
								</span>
								<span>
									<Typography>소속</Typography>
								</span>
								<span>
									<Typography>언어</Typography>
								</span>
							</div>
							<List id="classinfo">
								{ClassList != null &&
									ClassList.map((item: any, index: number) => {
										return (
											<AppListItem
												index={index}
												name={item.operator_name}
												email={item.operator_email}
												phone={item.operator_phone}
												affiliation={item.affiliation}
												language={item.language}
												checked={checkedCodes.includes(item.operator_email)}
												onCheckboxChange={handleCheckboxChange}
											/>
										);
									})}
								<div className={classes.blank} ref={loader}></div>
							</List>
						</div>
						<div className={classes.bottomField}>
							<TextField
								className={`${classes.selectField} ${classes.selectRoot}`}
								//variant="outlined"
								label="소속 선택"
								select
								fullWidth
								value={affiliation}
								InputLabelProps={{ shrink: true, className: classes.selectLabel }}
								onChange={(e) => setAffiliation((e.target as HTMLInputElement).value)}
								SelectProps={{
									MenuProps: {
										getContentAnchorEl: null,
										anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
										transformOrigin: { vertical: 'top', horizontal: 'left' },
										classes: { paper: classes.menuPaper },
									},
								}}
							>
								<MenuItem className={classes.menuItem} value="유스타터">
									유스타터
								</MenuItem>
								<MenuItem className={classes.menuItem} value="대구행복한미래재단">
									대구행복한미래재단
								</MenuItem>
								<MenuItem className={classes.menuItem} value="교사">
									교사
								</MenuItem>
								<MenuItem className={classes.menuItem} value="null">
									무소속
								</MenuItem>
							</TextField>
							<Button className={classes.operApprove} onClick={postOperAffiliate}>
								<Typography>소속 변경</Typography>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { index, name, email, phone, affiliation, language, checked } = props;
	const [isChecked, setIsChecked] = useState(checked);

	useEffect(() => {
		setIsChecked(checked);
	}, [checked]);

	const handleCheckboxChange = (event: any) => {
		setIsChecked(event.target.checked);
		props.onCheckboxChange(email, event.target.checked);
	};

	return (
		<ListItem id={index} className={classes.classInfo}>
			<Checkbox checked={isChecked} onChange={handleCheckboxChange} inputProps={{ 'aria-label': 'primary checkbox' }} />
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{email}</Box>
			<Box className={classes.buttonLabel}>{phone}</Box>
			<Box className={classes.buttonLabel}>{affiliation === null ? '미등록' : affiliation}</Box>
			<Box className={classes.buttonLabel}>{language === 'en' ? '영어' : '한국어'}</Box>
		</ListItem>
	);
};

export default SubAdminOperAffiliate;
